<template>
  <div>
    <!-- 登陆背景 -->
    <div>
      <img class="picture" src="../assets/pictures/bj.jpg" alt="" />
    </div>

    <div class="login_box">
      <!-- 左侧区域 -->
      <div class="left-section">
        <img src="../assets/pictures/bonuoLogo.png" alt="" class="centered-image" />
      </div>

      <!-- 右侧区域 -->
      <div class="right-section">
        <h1 class="fonts">用户登录</h1>
        <el-form :model="loginForm" ref="loginFormRef" :rules="loginFormRules" class="login_form">
          <!-- 用户名 -->
          <el-form-item prop="ID">
            <el-input prefix-icon="el-icon-s-custom" placeholder="请输入用户名" v-model="loginForm.ID" style="width: 45%;"></el-input>
          </el-form-item>
          <!-- 密码 -->
          <el-form-item prop="Pwd">
            <el-input
              prefix-icon="el-icon-lock"
              placeholder="请输入密码"
              v-model="loginForm.Pwd"
              type="password" style="width: 45%;"
              @keyup.enter.native="login"
            ></el-input>

          </el-form-item>
          <!-- 按钮区域 -->
          <el-form-item >
            <el-button class="logbbtn" type="primary" @click="login">登录</el-button>

          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios'
import qs from 'qs'

export default {
    name: 'Login',
    data () {
        return {
            loginForm: {
                ID: '',
                Pwd: '',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms'
            },
            //表单的验证规则对象
            loginFormRules: {
                //验证用户名是否合法
                ID: [
                    { required: true, message: '请输入登录名称', trigger: 'blur' },
                    { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
                ],
                //验证密码是否合法
                Pwd: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 3, max: 15, message: '长度在 6 到 15位', trigger: 'blur' }
                ]
            }
        }
    },
    created () {
      // 首次打开项目需要调用
      // this.firstLoad()
    },
    methods: {
      firstLoad() {
        try {
          this.$http.post("/WMS/conn_mqtt")
        } catch (error) {

        }
      },
        //点击重置按钮，重置登录表单
        resetLoginForm ()
        {
            this.$refs.loginFormRef.resetFields();
        },
        //表单检验
        login () {
            this.$refs.loginFormRef.validate(async valid => {
                if (!valid) return
                let params = new URLSearchParams();
                params.append("ID", this.loginForm.ID)
                params.append("Pwd", this.loginForm.Pwd)
                params.append("privateKey", this.loginForm.privateKey)
                params.append("appIdentification", this.loginForm.appIdentification)
                const { data: res } = await this.$http.post("/WMS/verifyUser", params);

                if (res.code !== 1) return    this.$message.success(res.Message)

                this.$message.success(res.Message)
                window.sessionStorage.setItem('token', this.loginForm.ID)

                this.$router.push("/common")
            })
        }

    },
  //   created() {
  //     let reg = location.href
  //     let strArr = reg.split('=')
  //     let token = strArr[1]

  // axios.post('http://192.168.1.110:803/IDM/SystemObtainUser',qs.stringify({
  //   PrivateKey:'d265e452-4e9a-74b8-5092-01d00539a1de',
  //     AppIdentification:'WMS',
  //     Token:token
  // })).then(res=>{
  //   console.log(111,res);
  //    window.sessionStorage.setItem('token', res.data.data.UserNumber)

  //               this.$router.push("/common")
  // })

  //   },

}
</script>



<style lang="less" scoped>
.logbbtn{

  height: 40px; /* 设置按钮的高度，与输入框一样 */
  width: 45%; /* 设置按钮的宽度，与输入框一样 */

  color: white; /* 设置按钮的文字颜色为白色 */
  border: none; /* 去掉按钮的边框 */
  margin-top: 10px; /* 设置按钮与上面元素的间距 */
}
.fonts {
  transform: translateX(40%);
  -ms-transform: translateX(35%);
  -webkit-transform: translateX(35%);
  color: rgb(236, 236, 236);
}
.picture {
  background-size: 100% 100%;
  position: fixed;
  width: 100%;
  height: 100%;
}
.login_box {
  display: flex; /* 使用 flex 布局 */
  width: 40%;
  height: 35%;
  background-color: rgba(201, 222, 235, 0.7);
  border-radius: 13px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.left-section {
  flex: 1; /* 左侧区域占据 50% 的宽度 */
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  border-right: 1px solid #ccc; /* 添加分割线 */
}

.right-section {
  flex: 1; /* 右侧区域占据 50% 的宽度 */
  padding: 20px;
}

.centered-image {
  max-width: 100%;
  max-height: 100%;
}

.btns {
  display: flex;
  justify-content: center;
  margin-top: 12%;
}
.login_form {
  position: absolute;
  bottom: 15%;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}
</style>
